import { configureStore } from "@reduxjs/toolkit";
import nftsReducer from '../nfts/nftsSlice';

export const store = configureStore({
    reducer: {
        nfts: nftsReducer,
    },
    devTools: process.env.NODE_ENV === 'development'
});